import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logo.svg";
import dashboard_icn from "../../../assets/images/dashboard.svg";
import societies_icn from "../../../assets/images/societies.svg";
import finance_icn from "../../../assets/images/finance-icon.svg";
import complaints_icn from "../../../assets/images/complaints-icon.svg";
import signout_icn from "../../../assets/images/signout.svg";
import setting_icn from "../../../assets/images/settings.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import "./sidebar.scss";
import { Button, Modal } from "antd";

const SidebarComponent = (props) => {
  const { open } = props;
  const [isActive, setIsActive] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const navigate = useNavigate();
  const cookies = new Cookies();
  const handleLogOutScreen = () => {
    setConfirmModal(true);
  };

  const handleConfirmeLogOut = () => {
    cookies.remove("token", { path: "/" });
    cookies.remove("role", { path: "/" });
    cookies.remove("societyId", { path: "/" });
    cookies.remove("society_id", { path: "/" });
    cookies.remove("society_name", { path: "/" });
    setIsLoggedIn(false);
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    if (!cookies.get("token")) {
      setIsLoggedIn(false);
      navigate("/");
    }
  }, [cookies]);

  const handlelogoClick = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    let route = window.location.pathname;

    if (route === "/dashboard") {
      setIsActive("Dashboard");
    } else if (route.includes("/society-details")) {
      setIsActive("Dashboard");
    } else if (route.includes("/president-details")) {
      setIsActive("Dashboard");
    } else if (route.includes("/edit-president")) {
      setIsActive("Societies");
    } else if (route.includes("/edit-details")) {
      setIsActive("Societies");
    } else if (route.includes("/manage-users")) {
      setIsActive("Societies");
    } else if (route.includes("/society-permissions")) {
      setIsActive("Societies");
    } else if (route.includes("/society-images")) {
      setIsActive("Societies");
    } else if (route.includes("/to-be-registered")) {
      setIsActive("Societies");
    } else {
      switch (route) {
        case "/society-list":
          setIsActive("Societies");
          break;
        case "/finance":
          setIsActive("Finance");
          break;
        case "/coming-soon":
          setIsActive("Finance");
          break;
        case "/help-desk":
          setIsActive("Help Desk Tickets");
          break;
        case "/settings":
          setIsActive("Settings");
          break;
      }
    }
  }, [window.location.pathname]);

  const handleClick = (event) => {
    setIsActive(event);
  };

  return (
    <>
      <div className={open === true ? `menu` : `sidebar-main`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={logo} alt="Logo" onClick={handlelogoClick} />
          </div>
        </div>
        <div className="sidebar-menu">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              width: "100%",
            }}
          >
            <Link to="/dashboard" onClick={() => handleClick("Dashboard")}>
              <div
                className={isActive === "Dashboard" ? "active" : "sidebar-text"}
              >
                <img src={dashboard_icn} alt="" />
                <div className="sidebar-item">Dashboard</div>
              </div>
            </Link>
            <Link to="/society-list" onClick={() => handleClick("Societies")}>
              <div
                className={isActive === "Societies" ? "active" : "sidebar-text"}
              >
                <img src={societies_icn} alt="" />
                <div className="sidebar-item">Societies</div>
              </div>
            </Link>
            <Link
              to="/help-desk"
              onClick={() => handleClick("Help Desk Tickets")}
            >
              <div
                className={
                  isActive === "Help Desk Tickets" ? "active" : "sidebar-text"
                }
              >
                <img src={complaints_icn} alt="" />
                <div className="sidebar-item">Help Desk</div>
              </div>
            </Link>
            <Link to="/finance" onClick={() => handleClick("Finance")}>
              <div
                className={isActive === "Finance" ? "active" : "sidebar-text"}
              >
                <img src={finance_icn} alt="" />
                <div className="sidebar-item">Finance</div>
              </div>
            </Link>

            <Link to="/settings" onClick={() => handleClick("Settings")}>
              <div
                className={isActive === "Settings" ? "active" : "sidebar-text"}
              >
                <img src={setting_icn} alt="" />
                <div className="sidebar-item">Settings</div>
              </div>
            </Link>
          </div>
        </div>
        <div className="sidebar-footer">
          <div className="sidebar-footer-text" onClick={handleLogOutScreen}>
            <img src={signout_icn} alt="" />
            <div className="sidebar-item">Log out</div>
          </div>
        </div>
      </div>
      <Modal
        centered
        open={confirmModal}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setConfirmModal(false)}
        className="approve-popup"
      >
        <div
          style={{
            padding: "30px",
            textAlign: "center",
            backgroundColor: "#fefefe",
            borderRadius: "16px",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "16px",
              color: "#333",
            }}
          >
            Are you sure you want to log out ?
          </div>
          <div
            style={{
              fontSize: "16px",
              color: "#777",
              marginBottom: "24px",
              lineHeight: "1.5",
            }}
          >
            We’ll miss you! 💙
            <br />
            Take care and see you again soon!
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Button
              type="primary"
              danger
              onClick={() => setConfirmModal(false)}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                backgroundColor: "#ff7875",
                borderColor: "#ff7875",
              }}
            >
              Stay Here ❤️
            </Button>
            <Button
              type="primary"
              onClick={handleConfirmeLogOut}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                backgroundColor: "#d6ad61",
                borderColor: "#d6ad61",
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SidebarComponent;
